<template>
  <div class="detailBaseItem">
    <div class="title">{{ title }}</div>
    <div class="desc">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: [String],
    desc: [String]
  }
};
</script>
<style lang="scss" scoped>
.detailBaseItem {
  display: flex;
  margin-bottom: 20px;
  &:first-child {
    margin-top: 0;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #4b90ff;
    margin-right: 10px;
  }
  .desc {
    font-size: 16px;
    color: #333;
    flex: 1;
  }
}
</style>
